import { CalendarDays } from "lucide-react"

export default function AgendaStartStep() {
  return (
    <section className="flex flex-col gap-4">
      <header className="flex items-center gap-2">
        <span className="w-fit rounded-lg bg-primary-50 p-1.5">
          <CalendarDays className="size-4 text-primary-500" />
        </span>
        <h1 className="text-base font-bold">Agenda</h1>
      </header>
      <img
        className="w-full object-contain"
        src="https://storage.googleapis.com/educabot-aec-cdn-1/tuni/product-tour/agenda-start.gif"
      />
      <p className="text-left text-sm text-muted-foreground">
        Acá podés ver y crear tus eventos. Esto nos va a ayudar a encontrar el tiempo de estudio
        óptimo para vos. ¡Es el primer paso para armar tu rutina!
      </p>
    </section>
  )
}
